import React, { useEffect, useRef, useState } from 'react';
import AR_ios from './AR_ios';
import Android from './Android';
import '@google/model-viewer/dist/model-viewer';

import refregratorimg from "../assets/1.png"
import ovenimg from "../assets/2.jpg"
import hoodimg from "../assets/3.jpg"
import dishwasherimg from "../assets/4.jpg"
import close from "../assets/icons8-close-24.png"
import fullscreneimg from "../assets/full-size.png"
import arimg from "../assets/ar.png"
// import boximg from "../assets/box.png"
import boximg from "../assets/logo.jpeg"
import left from "../assets/icons8-forward-30.png"
import Loading from './Loading/Loading';
import ARA from './androindNew';

export default function Viewer() {
    // let door = ['model/door.glb']
    // let door = ['model/lean.glb']
    let door = ['model/NamakAbrood-dark.glb']
    
    const modelViewerRef = useRef(null);

    const [model, setChangeModel] = useState(door[0])
    const ShowModal = () => {
        document.querySelector(".modal").style.display = "flex"
    }

    const CloseModal = () => {
        document.querySelector(".modal").style.display = "none"
    }

    const OpenAR = () => {
        document.getElementById("ar-button").click()
    }

    function toggleFullScreen() {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else if (document.exitFullscreen) {
            document.exitFullscreen();
        }
    }


    const slideIndex = useRef(1);

    const handleProgress = () => {
        setTimeout(() => {
            document.getElementById("Loading").style.display = "none"
        }, 10000);

    }

    useEffect(() => {
        const modelViewer = modelViewerRef.current;
    
        if (modelViewer) {
          const disableDefaultEvents = (event) => {
            event.preventDefault();
          };
    
          modelViewer.addEventListener('touchstart', disableDefaultEvents);
          modelViewer.addEventListener('mousedown', disableDefaultEvents);
          modelViewer.addEventListener('wheel', disableDefaultEvents);
    
          return () => {
            modelViewer.removeEventListener('touchstart', disableDefaultEvents);
            modelViewer.removeEventListener('mousedown', disableDefaultEvents);
            modelViewer.removeEventListener('wheel', disableDefaultEvents);
          };
        }
      }, [modelViewerRef]);

    return (
        <div>
            <>
                <Loading />
                <model-viewer  
                  src={model} 
                  ref={modelViewerRef}
                  shadow-intensity="1"
                  xr-environment
                    camera-controls 
                    environment-image="christmas_photo_studio_07_1k.hdr"
                    exposure="1"
                    scale="0.009 0.009 0.009" 
                    tone-mapping="neutral"
                    // touch-action="none"
                    // ar-scale="fixed"
                    loading="eager"
                    // rotation-per-second="5deg"
                    // fixed-scale  
                //    fixed-rotation
                //    interaction-prompt="none" 
                disable-tap 
                    onProgress={handleProgress()}
                    ar ar-modes=" scene-viewer quick-look  webxr"
                >

                    <button slot="ar-button" id="ar-button">
                    </button>
                </model-viewer>

            </>


         
            <div className="panelTop" >
        <div className="boxpanel">
            {/* <img className="img" src={boximg} alt="Image 1"/> */}
            <img className="img" src={arimg} onClick={OpenAR} alt="Image 2"/>
           </div>
           </div>

            {/* <div className="panelTop" id="panelTop">
                <div className="boxpanel">
                    <div className="img" onClick={() => ShowModal('product')}>
                    <div className="img" >
                        <img src={boximg} />
                    </div>
                    <div className="img" >
                        <img src={showimg} style={{ opacity: '70%' }} />
                    </div>
                    <div className="img">
                        <img src={arimg} onClick={OpenAR} />
                    </div>
                    <div className="img">
                        <img src={fullscreneimg} onClick={toggleFullScreen} style={{ width: '20px', opacity: '85%' }} />
                    </div>
                </div>
            </div>



          


        </div > */}

        </div>
    )

}

